import { render, staticRenderFns } from "./AnnouncementPill.vue?vue&type=template&id=62be404a"
import script from "./AnnouncementPill.vue?vue&type=script&lang=js"
export * from "./AnnouncementPill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports